const getBlankNode = (value = '') => ({
  root: {
    children: [
      {
        children: [
          {
            detail: 0,
            format: 0,
            mode: 'normal',
            style: '',
            text: value,
            type: 'text',
            version: 1
          }
        ],
        direction: null,
        format: '',
        indent: 0,
        type: 'paragraph',
        version: 1
      }
    ],
    direction: null,
    format: '',
    indent: 0,
    type: 'root',
    version: 1
  }
});

const formatLexicalInitialValue = (value) => {
  value = typeof value === 'number' ? String(value) : value;

  const empty = `{"root":{"children":[],"direction":null,"format":"","indent":0,"type":"root","version":1}}`;
  if (value === empty || String(value || '').trim() === '') {
    return null;
  }
  if (typeof value === 'string') {
    if (!String(value).includes('root')) {
      const newNode = getBlankNode(value);
      return formatLexicalInitialValue(JSON.stringify(newNode));
    }
    try {
      if (JSON.parse(value)) {
        return value;
      }
    } catch (e) {
      const newNode = getBlankNode(value);
      return formatLexicalInitialValue(JSON.stringify(newNode));
    }
  }
  if (typeof value === 'object') {
    if (value?.type === 'lexical') {
      value = value?.value;
    }
    if (value?.root?.children?.length === 0 || value?.root === undefined) {
      return null;
    }
    return formatLexicalInitialValue(JSON.stringify(value));
  }
  return null;
};

export default formatLexicalInitialValue;
